import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { HttpService } from './services/http/http.service';
import { ManejadorErroresService } from './services/manejador-errores/manejador-errores.service';
import { erroresHttpInterceptor } from './interceptors/errores-http/errores-http.interceptor';
import { loadingInterceptor } from './interceptors/loading/loading.interceptor';
import { recaptchaInterceptor } from './interceptors/recaptcha/recaptcha.interceptor';
import { provideInicializacionRutasModyo } from './initializers/rutas-modyo.initializer';
import { provideTracking } from './services/tracking/tracking.config';
import { EVENT_BRIDGE_CONFIG } from './services/event-bridge/event-bridge.tokens';
import { environment } from '@env/environment';

export const coreConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withFetch(),
      withInterceptors([recaptchaInterceptor, loadingInterceptor, erroresHttpInterceptor]),
    ),
    HttpService,
    {
      provide: ErrorHandler,
      useClass: ManejadorErroresService,
    },
    provideInicializacionRutasModyo(),
    { provide: EVENT_BRIDGE_CONFIG, useValue: environment.eventBridgeConfig },
    provideTracking(environment.trackingConfig),
  ],
};
